const numberFormat = (num,pos)=>{
    return (num).toFixed(pos).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}


const formatThDate = (date)=>{
    let _ymd = date.substring(0,10).split("-");
    return _ymd[2]+"/"+_ymd[1]+"/"+_ymd[0];
}

const summary = (items, prop)=>{
        console.log(items);
        if(items !== undefined){
        return items.reduce( function(a, b){
            return a + b[prop];
        }, 0);
        }else{
            return 0;
        }
    }

const mapPostCode2Province = (items) =>{
    console.log(items);
}

module.exports = {
    numberFormat,
    formatThDate,
    summary,
    mapPostCode2Province
}